<div class="card-base">
    <div class="card-content-reservation-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{ filt.toolTip }}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-admission-integrated-filter #filters></app-admission-integrated-filter>
                </div>
                <div class="pull-right div-header-right">
                    <mat-spinner *ngIf="loadingMasiveAction" diameter="50"> </mat-spinner>
                    <button *ngIf="!loadingMasiveAction" class="card-inline margin-top-medium" [matMenuTriggerFor]="menuItem" type="button" mat-mini-fab>
            <mat-icon>more_vert</mat-icon>
          </button>

                    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
                    <mat-menu #menuItem="matMenu">
                        <button (click)="controled()" mat-menu-item>
              <span> <b>Controlado</b></span>
            </button>
                        <button (click)="rollBackControled()" mat-menu-item>
              <span> <b>Revertir control</b></span>
            </button>
                    </mat-menu>
                </div>
            </div>
            <mat-divider></mat-divider>

            <div class="card-content margin-botton-medium">
                <p-scrollPanel styleClass="scroll-panel">
                    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="Select">
                            <th class="checkbox-column" mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                                </mat-checkbox>
                            </th>
                            <td class="checkbox-column" mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <th class="search-table-header resizable-column" mat-header-cell #resThFecha *matHeaderCellDef>
                                <resizable-column-control width="150" tile="Fecha" #resColFecha></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>
                                    <b>{{ element.DateTime | date: "dd/MM/yyyy HH:mm" }}</b>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="receptionDate">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Recepcionado" #resColReceptionDate></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>
                                    {{ element.ReceptionDate | date: "dd/MM/yyyy HH:mm" }}
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="stateName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Estado" #resColState></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.StateName }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="isOverAppointment">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Es sobreturno" #resColIsOverAppointment></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.IsOverAppointment ? "Sí" : "No" }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="isReAppointmentYesNo">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Es recitado" #resColIsReAppointmentYesNo></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.IsReAppointment ? "Sí" : "No" }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="patientLasNameFirstName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="150" tile="Paciente" #resColPatient></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.PatientLastNameFirstName }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="protocol">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="150" tile="Protocolo" #resColProtocol></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.Protocol }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="practiceRegionName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="150" tile="Práctica" #resColPractice></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.PracticeRegionName }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="equipmentName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Equipo" width="150" #resColEquipmentName></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.EquipmentName }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="physicianLastNameFirstName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="150" tile="Médico actuante" #resColPhysicianLastNameFirstName></resizable-column-control>
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.PhysicianLastNameFirstName }}</div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="entityName">
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef>
                                Entidad
                            </th>
                            <td (click)="admissionEdit(element)" class="search-table-cell" mat-cell *matCellDef="let element">
                                <div>{{ element.EntityName }}</div>
                            </td>
                        </ng-container>

                        <!-- Star Column -->
                        <ng-container matColumnDef="star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="admissionEdit(element)">
                    <mat-icon>edit</mat-icon><span>Editar</span>
                  </button>

                                    <button mat-menu-item *ngIf="canChangeAppointmentDate" (click)="changeAppointmentDate(element)">
                    <mat-icon>edit</mat-icon
                    ><span>Cambiar fecha recepción</span>
                  </button>
                                    <button mat-menu-item (click)="admissionView(element)">
                    <mat-icon>search</mat-icon><span>Ver</span>
                  </button>
                                    <button mat-menu-item (click)="openLogViewDialog(element)">
                    <mat-icon>search</mat-icon><span>Ver actividades</span>
                  </button>
                                    <button mat-menu-item (click)="openMedicalAppointmentObservationDialog(element)">
                    <mat-icon>search</mat-icon><span>Observaciones</span>
                  </button>
                                    <button *ngIf="element.IsReAppointment" mat-menu-item (click)="assignMedicalAppointment(element)">
                    <mat-icon>edit</mat-icon><span>Asignar turno</span>
                  </button>
                                    <button mat-menu-item *ngIf="canCancelAdmited" (click)="openMedicalAppointmentCancelDialog(element)">
                    <mat-icon>cancel</mat-icon><span>Cancelar</span>
                  </button>

                                    <button mat-menu-item (click)="openLaboratoryAppointmentQuestionDialog(element)">
                    <mat-icon>help</mat-icon><span>Preguntas laboratorio</span>
                  </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>